const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Per-service ports for localhost — e.g. REACT_APP_PORT_USERS=3001
const SERVICE_PORTS: Record<string, string | undefined> = {
  users: process.env.REACT_APP_PORT_USERS,
  surveys: process.env.REACT_APP_PORT_SURVEYS,
  notification: process.env.REACT_APP_PORT_NOTIFICATION,
  faq: process.env.REACT_APP_PORT_FAQ,
  wallet: process.env.REACT_APP_PORT_WALLET,
  dashboard: process.env.REACT_APP_PORT_DASHBOARD,
};

export const getServiceUrl = (serviceName: string): string => {
  const port = SERVICE_PORTS[serviceName];
  if (API_BASE_URL.endsWith(':') && port) {
    return `${API_BASE_URL}${port}`;
  }
  return `${API_BASE_URL}/${serviceName}`;
};

export const API_SERVICES = {
  USERS: 'users',
  SURVEYS: 'surveys',
  NOTIFICATION: 'notification',
  FAQ: 'faq',
  WALLET: 'wallet',
  DASHBOARD: 'dashboard',
} as const;

export const getApiUrl = (service: keyof typeof API_SERVICES): string => {
  return getServiceUrl(API_SERVICES[service]);
};
